import { render, staticRenderFns } from "./CenterPanel.vue?vue&type=template&id=3efbae16&scoped=true&"
import script from "./CenterPanel.vue?vue&type=script&lang=js&"
export * from "./CenterPanel.vue?vue&type=script&lang=js&"
import style0 from "./CenterPanel.vue?vue&type=style&index=0&id=3efbae16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efbae16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efbae16')) {
      api.createRecord('3efbae16', component.options)
    } else {
      api.reload('3efbae16', component.options)
    }
    module.hot.accept("./CenterPanel.vue?vue&type=template&id=3efbae16&scoped=true&", function () {
      api.rerender('3efbae16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/CenterPanel.vue"
export default component.exports